import { useContext } from "react";
import { APP_LANGUAGES } from "utils/language";
import { QuizContext, QuizContextState } from "../QuizContext";
import { QuizQuestion } from "../quizTypes";

const useQuizState = () => {
  const quizState = useContext<QuizContextState | null>(QuizContext);

  if (typeof quizState === "undefined" || typeof quizState !== "object") {
    return {
      quizSlug: "",
      quizBaseSlug: "quiz",
      quizLanguage: APP_LANGUAGES.ENGLISH,
      questions: [] as QuizQuestion[],
      numberQuestions: 0,
      currentQuestion: undefined,
      updateCurrentQuestion: () => {},
      updateQuestion: () => {},
      onNext: () => {},
      onBack: () => {},
      onClose: () => {},
      isSubmittingQuiz: false,
      currentQuestionIndex: undefined,
      errorState: undefined,
      handleRestartQuiz: () => {},
      showAddressAdditionalFields: false,
      resetAddressAdditionalInfoFields: () => {},
      phoneVerificationEnabled: false,
      sliderLoaderEnabled: false,
      quizSubmissionRedirectLink: undefined
    };
  }

  return quizState as QuizContextState;
};

export type QuizContextType = ReturnType<typeof useQuizState>;

export default useQuizState;
